import { useEffect, useState } from "react";
import axios from "axios";
import { Star, Quote } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function Stars({ rating }) {
  return (
    <div className="flex items-center gap-1" aria-label={`${rating} von 5 Sternen`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`h-4 w-4 ${i <= rating ? "fill-[#F5B301] text-[#F5B301]" : "text-white/20"}`}
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}

export default function Reviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios
      .get(`${BACKEND}/api/reviews`)
      .then((res) => setReviews(res.data))
      .catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section id="kundenstimmen" data-testid="reviews-section" className="relative">
      <div className="border-y border-white/10 px-6 py-20 lg:px-16 lg:py-28">
        <Reveal>
          <p className="font-tac text-xs tracking-[0.3em] text-[#F5B301]">KUNDENSTIMMEN</p>
          <h2 className="mt-6 max-w-4xl font-display text-4xl font-black uppercase leading-[0.9] tracking-tighter sm:text-5xl lg:text-7xl">
            Was Kunden <span className="text-stroke">sagen.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 0.1}>
              <article
                data-testid={`review-${r.id}`}
                className="group relative flex h-full flex-col border border-white/10 bg-white/[0.02] p-8 transition-colors duration-500 hover:border-[#F5B301]/40 lg:p-10"
              >
                <Quote className="h-8 w-8 text-[#F5B301]/40 transition-colors duration-500 group-hover:text-[#F5B301]" strokeWidth={1.5} />
                <Stars rating={r.rating} />
                <p className="mt-6 flex-1 font-tac text-sm leading-relaxed text-[#D4D4D8]">
                  „{r.text}"
                </p>
                <div className="mt-8 border-t border-white/10 pt-5">
                  <p className="font-display text-lg font-black uppercase tracking-tighter text-white">
                    {r.name}
                  </p>
                  {r.role && (
                    <p className="mt-1 font-tac text-[10px] uppercase tracking-[0.25em] text-[#F5B301]/80">
                      {r.role}
                    </p>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
